var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 780,
    viewBox: "0 0 640 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_761_429)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 780,
    fill: "#36AAFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("line", {
    x1: 285.5,
    y1: 824,
    x2: 285.5,
    y2: 464,
    stroke: "white",
    strokeOpacity: 0.02
  }), /*#__PURE__*/React.createElement("line", {
    x1: 265.5,
    y1: 824,
    x2: 265.5,
    y2: 464,
    stroke: "white",
    strokeOpacity: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.5,
    y1: 824,
    x2: 245.5,
    y2: 464,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.5,
    y1: 824,
    x2: 225.5,
    y2: 464,
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.5,
    y1: 824,
    x2: 205.5,
    y2: 464,
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.5,
    y1: 824,
    x2: 185.5,
    y2: 464,
    stroke: "white",
    strokeOpacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.5,
    y1: 824,
    x2: 165.5,
    y2: 464,
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.5,
    y1: 824,
    x2: 145.5,
    y2: 464,
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.5,
    y1: 824,
    x2: 125.5,
    y2: 464,
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.5,
    y1: 824,
    x2: 105.5,
    y2: 464,
    stroke: "white",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.5,
    y1: 824,
    x2: 85.5,
    y2: 464,
    stroke: "white",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.5,
    y1: 824,
    x2: 65.5,
    y2: 464,
    stroke: "white",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.5,
    y1: 824,
    x2: 45.5,
    y2: 464,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 824,
    x2: 25.5,
    y2: 464,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 824,
    x2: 5.50005,
    y2: 464,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 770.5,
    x2: -372,
    y2: 770.5,
    stroke: "url(#paint0_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 750.5,
    x2: -372,
    y2: 750.5,
    stroke: "url(#paint1_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 730.5,
    x2: -372,
    y2: 730.5,
    stroke: "url(#paint2_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 710.5,
    x2: -372,
    y2: 710.5,
    stroke: "url(#paint3_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 690.5,
    x2: -372,
    y2: 690.5,
    stroke: "url(#paint4_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 670.5,
    x2: -372,
    y2: 670.5,
    stroke: "url(#paint5_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 650.5,
    x2: -372,
    y2: 650.5,
    stroke: "url(#paint6_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 630.499,
    x2: -372,
    y2: 630.499,
    stroke: "url(#paint7_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 610.499,
    x2: -372,
    y2: 610.499,
    stroke: "url(#paint8_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 590.499,
    x2: -372,
    y2: 590.499,
    stroke: "url(#paint9_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 570.499,
    x2: -372,
    y2: 570.499,
    stroke: "url(#paint10_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 550.499,
    x2: -372,
    y2: 550.499,
    stroke: "url(#paint11_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 530.499,
    x2: -372,
    y2: 530.499,
    stroke: "url(#paint12_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 510.499,
    x2: -372,
    y2: 510.499,
    stroke: "url(#paint13_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 490.499,
    x2: -372,
    y2: 490.499,
    stroke: "url(#paint14_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 470.499,
    x2: -372,
    y2: 470.499,
    stroke: "url(#paint15_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 450.499,
    x2: -372,
    y2: 450.499,
    stroke: "url(#paint16_linear_761_429)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_761_429)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -204,
    y: -131,
    width: 441,
    height: 496.964,
    rx: 55.9645,
    fill: "#4CDFFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_761_429)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 225,
    width: 441,
    height: 496.964,
    rx: 55.9645,
    fill: "#4CDFFF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("line", {
    x1: 43.5,
    y1: -16,
    x2: 43.5,
    y2: 344,
    stroke: "white",
    strokeOpacity: 0.02
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.5,
    y1: -16,
    x2: 63.5,
    y2: 344,
    stroke: "white",
    strokeOpacity: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.5,
    y1: -16,
    x2: 83.5,
    y2: 344,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.5,
    y1: -16,
    x2: 103.5,
    y2: 344,
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.5,
    y1: -16,
    x2: 123.5,
    y2: 344,
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.5,
    y1: -16,
    x2: 143.5,
    y2: 344,
    stroke: "white",
    strokeOpacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.5,
    y1: -16,
    x2: 163.5,
    y2: 344,
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.5,
    y1: -16,
    x2: 183.5,
    y2: 344,
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.5,
    y1: -16,
    x2: 203.5,
    y2: 344,
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.5,
    y1: -16,
    x2: 223.5,
    y2: 344,
    stroke: "white",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.5,
    y1: -16,
    x2: 243.5,
    y2: 344,
    stroke: "white",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.5,
    y1: -16,
    x2: 263.5,
    y2: 344,
    stroke: "white",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.5,
    y1: -16,
    x2: 283.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.5,
    y1: -16,
    x2: 303.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 323.5,
    y1: -16,
    x2: 323.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.5,
    y1: -16,
    x2: 343.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.5,
    y1: -16,
    x2: 363.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.5,
    y1: -16,
    x2: 383.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.5,
    y1: -16,
    x2: 403.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.5,
    y1: -16,
    x2: 423.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.5,
    y1: -16,
    x2: 443.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 463.5,
    y1: -16,
    x2: 463.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 483.5,
    y1: -16,
    x2: 483.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 503.5,
    y1: -16,
    x2: 503.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 523.5,
    y1: -16,
    x2: 523.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.5,
    y1: -16,
    x2: 543.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.5,
    y1: -16,
    x2: 563.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 583.5,
    y1: -16,
    x2: 583.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 603.5,
    y1: -16,
    x2: 603.5,
    y2: 344,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 623.5,
    y1: -16,
    x2: 623.5,
    y2: 344,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 17.5,
    x2: 701,
    y2: 17.5001,
    stroke: "url(#paint17_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 37.5,
    x2: 701,
    y2: 37.5001,
    stroke: "url(#paint18_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 57.5,
    x2: 701,
    y2: 57.5001,
    stroke: "url(#paint19_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 77.5,
    x2: 701,
    y2: 77.5001,
    stroke: "url(#paint20_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 97.5,
    x2: 701,
    y2: 97.5001,
    stroke: "url(#paint21_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 117.5,
    x2: 701,
    y2: 117.5,
    stroke: "url(#paint22_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 137.5,
    x2: 701,
    y2: 137.5,
    stroke: "url(#paint23_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 157.5,
    x2: 701,
    y2: 157.5,
    stroke: "url(#paint24_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 177.501,
    x2: 701,
    y2: 177.501,
    stroke: "url(#paint25_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 197.501,
    x2: 701,
    y2: 197.501,
    stroke: "url(#paint26_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 217.501,
    x2: 701,
    y2: 217.501,
    stroke: "url(#paint27_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 237.501,
    x2: 701,
    y2: 237.501,
    stroke: "url(#paint28_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 257.501,
    x2: 701,
    y2: 257.501,
    stroke: "url(#paint29_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 277.501,
    x2: 701,
    y2: 277.501,
    stroke: "url(#paint30_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 297.501,
    x2: 701,
    y2: 297.501,
    stroke: "url(#paint31_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 317.501,
    x2: 701,
    y2: 317.501,
    stroke: "url(#paint32_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 337.501,
    x2: 701,
    y2: 337.501,
    stroke: "url(#paint33_linear_761_429)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 357.501,
    x2: 701,
    y2: 357.501,
    stroke: "url(#paint34_linear_761_429)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_761_429)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.906,
    y: 182.686,
    width: 203.088,
    height: 77.7536,
    rx: 6.96301,
    transform: "rotate(90 128.906 182.686)",
    fill: "url(#paint35_linear_761_429)",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 61.5938,
    y: 317.304,
    width: 55.5918,
    height: 55.5918,
    rx: 12.3537,
    fill: "#F1FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M93.2838 349.732L101.435 341.58C102.628 340.388 103.296 338.773 103.296 337.089V334.377C103.296 332.622 101.875 331.201 100.121 331.201H97.4088C95.7242 331.201 94.1095 331.87 92.9186 333.062L84.7656 341.213L79.3006 340.432C77.5747 340.186 75.8266 341.08 75.055 342.784C74.3532 344.335 74.8216 346.175 76.0267 347.379L87.1186 358.471C88.3221 359.674 90.1623 360.142 91.7136 359.441C93.4172 358.669 94.3127 356.921 94.065 355.195L93.2838 349.732Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1472 340.728C97.4626 340.728 98.5288 339.662 98.5288 338.346C98.5288 337.031 97.4626 335.965 96.1472 335.965C94.8319 335.965 93.7656 337.031 93.7656 338.346C93.7656 339.662 94.8319 340.728 96.1472 340.728Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8035 347.078C91.1188 347.078 92.1851 346.011 92.1851 344.696C92.1851 343.381 91.1188 342.314 89.8035 342.314C88.4882 342.314 87.4219 343.381 87.4219 344.696C87.4219 346.011 88.4882 347.078 89.8035 347.078Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2479 349.608C78.0574 349.75 77.8653 349.889 77.6938 350.061C76.557 351.198 75.6234 354.649 75.0693 357.161C74.7708 358.514 75.9774 359.721 77.3302 359.422C79.8404 358.868 83.2937 357.934 84.4306 356.798C84.6036 356.625 84.7433 356.434 84.8831 356.244L78.2479 349.608Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.5938,
    y: 255.798,
    width: 55.5918,
    height: 55.5918,
    rx: 12.3537,
    fill: "#F1FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M101.731 269.488H77.0472C74.126 269.488 71.7578 271.856 71.7578 274.778V292.409C71.7578 295.33 74.126 297.699 77.0472 297.699H101.731C104.653 297.699 107.021 295.33 107.021 292.409V274.778C107.021 271.856 104.653 269.488 101.731 269.488Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1982 280.067C100.146 280.067 101.724 278.488 101.724 276.541C101.724 274.593 100.146 273.015 98.1982 273.015C96.2506 273.015 94.6719 274.593 94.6719 276.541C94.6719 278.488 96.2506 280.067 98.1982 280.067Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2812 290.646C75.2812 291.113 75.467 291.562 75.7977 291.892C76.1283 292.223 76.5768 292.409 77.0444 292.409H101.728C102.196 292.409 102.644 292.223 102.975 291.892C103.306 291.562 103.492 291.113 103.492 290.646C103.492 288.241 100.515 285.356 99.0837 285.356C97.652 285.356 96.3543 287.119 92.9127 287.119C88.6071 287.119 85.8601 278.304 82.3338 278.304C78.8075 278.304 75.2812 285.995 75.2812 290.646Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.5938,
    y: 194.29,
    width: 55.5918,
    height: 55.5918,
    rx: 12.3537,
    fill: "#F1FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M102.494 208.986C100.339 206.831 96.8448 206.831 94.6898 208.986L76.6547 226.987C76.161 227.481 75.8323 228.114 75.7129 228.802L74.7074 234.634C74.4899 235.897 75.587 236.992 76.8493 236.773L82.613 235.771C83.2965 235.651 83.9276 235.324 84.4181 234.834L102.494 216.789C104.651 214.634 104.651 211.141 102.494 208.986Z",
    fill: "#FF3C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1562 212.511L98.9605 220.315L102.205 217.083L94.4003 209.278L91.1562 212.511Z",
    fill: "#FF3C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3205 231.078L74.7074 234.634C74.4899 235.897 75.587 236.992 76.8493 236.773L80.3991 236.155L75.3205 231.078Z",
    fill: "#FF3C53"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bd_761_429)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 50,
    width: 203.088,
    height: 77.7536,
    rx: 6.96301,
    transform: "rotate(90 246 50)",
    fill: "url(#paint36_linear_761_429)",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 179.492,
    y: 194.921,
    width: 55.7041,
    height: 55.7041,
    rx: 12.3787,
    fill: "#F1FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M214.363 228.774C217.396 226.588 219.378 223.036 219.378 219.011C219.378 212.364 213.988 206.975 207.341 206.975C200.694 206.975 195.305 212.364 195.305 219.011C195.305 223.036 197.286 226.588 200.319 228.774L201.287 232.552H213.396L214.363 228.774Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.725 235.176L213.398 232.552H201.289L201.96 235.176C202.472 237.172 204.271 238.57 206.332 238.57H208.353C210.416 238.57 212.215 237.172 212.725 235.176Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.492,
    y: 128.707,
    width: 55.7041,
    height: 55.7041,
    rx: 12.3787,
    fill: "#F1FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M207.353 172.873C216.364 172.873 223.668 165.569 223.668 156.559C223.668 147.548 216.364 140.244 207.353 140.244C198.343 140.244 191.039 147.548 191.039 156.559C191.039 165.569 198.343 172.873 207.353 172.873Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.357 159.821C209.159 159.821 210.62 158.36 210.62 156.558C210.62 154.756 209.159 153.295 207.357 153.295C205.555 153.295 204.094 154.756 204.094 156.558C204.094 158.36 205.555 159.821 207.357 159.821Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.351 158.19C206.933 158.19 206.515 158.03 206.197 157.712C205.559 157.074 205.559 156.043 206.197 155.405L217.617 143.985C218.255 143.347 219.286 143.347 219.924 143.985C220.562 144.623 220.562 145.654 219.924 146.292L208.504 157.712C208.186 158.03 207.768 158.19 207.351 158.19Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.841 156.997C213.609 160.387 210.806 163.084 207.359 163.084C203.76 163.084 200.833 160.157 200.833 156.558C200.833 153.111 203.53 150.308 206.92 150.076L209.884 147.112C209.077 146.895 208.233 146.77 207.359 146.77C201.961 146.77 197.57 151.16 197.57 156.558C197.57 161.957 201.961 166.347 207.359 166.347C212.757 166.347 217.148 161.957 217.148 156.558C217.148 155.684 217.022 154.84 216.805 154.033L213.841 156.997Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.369 151.464C220.035 153.03 220.405 154.753 220.405 156.559C220.405 163.755 214.55 169.61 207.353 169.61C200.157 169.61 194.302 163.755 194.302 156.559C194.302 149.362 200.157 143.507 207.353 143.507C209.159 143.507 210.882 143.877 212.448 144.543L214.889 142.102C212.633 140.921 210.071 140.244 207.353 140.244C198.358 140.244 191.039 147.563 191.039 156.559C191.039 165.554 198.358 172.873 207.353 172.873C216.349 172.873 223.668 165.554 223.668 156.559C223.668 153.841 222.991 151.279 221.81 149.023L219.369 151.464Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.492,
    y: 62.4932,
    width: 55.7041,
    height: 55.7041,
    rx: 12.3787,
    fill: "#F1FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M214.307 104.272H200.381C198.073 104.272 196.203 102.402 196.203 100.094V80.5977C196.203 78.2902 198.073 76.4199 200.381 76.4199H210.129L218.485 84.7755V100.094C218.485 102.402 216.614 104.272 214.307 104.272Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.133 81.9903V76.4199L218.488 84.7755H212.918C211.379 84.7755 210.133 83.5292 210.133 81.9903Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.223 97.3495C200.937 97.3495 200.65 97.2504 200.418 97.0472C199.909 96.6019 199.858 95.8286 200.302 95.3208L204.585 90.4265C204.82 90.1548 205.13 90.0202 205.521 90.008C205.879 90.0129 206.217 90.1732 206.447 90.4473L208.547 92.9678L212.504 88.0197C212.928 87.4936 213.695 87.4055 214.224 87.8288C214.751 88.2522 214.837 89.0218 214.415 89.5492L209.52 95.667C209.29 95.9534 208.944 96.1222 208.577 96.1259C208.194 96.1809 207.86 95.9668 207.625 95.6866L205.484 93.1159L202.145 96.931C201.903 97.2088 201.564 97.3495 201.223 97.3495Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bd_761_429)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.922,
    y: 50,
    width: 76.5931,
    height: 78.9141,
    rx: 6.96301,
    transform: "rotate(90 128.922 50)",
    fill: "url(#paint37_linear_761_429)",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62.5078,
    y: 61.6943,
    width: 55.7041,
    height: 55.7041,
    rx: 12.3787,
    fill: "#F1FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M89.7462 87.5772L93.4121 75.3603C90.4773 74.4817 87.2143 74.3633 83.8247 75.3603C77.8865 77.107 73.3358 82.204 72.2807 88.3041C70.293 99.7941 80.1172 109.62 91.6072 107.631C97.7053 106.576 102.804 102.025 104.551 96.0867C105.548 92.697 105.43 89.432 104.551 86.4992L92.3341 90.1651C90.7473 90.6387 89.2706 89.1619 89.7462 87.5772Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4903 86.009L108.707 82.3431C107.108 77.0072 102.904 72.8034 97.5683 71.2041L93.9024 83.421C93.4288 85.0079 94.9055 86.4846 96.4903 86.009Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_761_429)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_761_429)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 539,
    width: 261,
    height: 164,
    rx: 8,
    fill: "url(#paint38_linear_761_429)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 539.5,
    width: 260,
    height: 163,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125 575.11H175.75",
    stroke: "url(#paint39_linear_761_429)",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 586.69H192.83",
    stroke: "url(#paint40_linear_761_429)",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 607.92H230.09",
    stroke: "url(#paint41_linear_761_429)",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 617.97H230.09",
    stroke: "url(#paint42_linear_761_429)",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 628.02H179.22",
    stroke: "url(#paint43_linear_761_429)",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 563H149.57",
    stroke: "url(#paint44_linear_761_429)",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.766 596.283C108.766 597.915 107.249 599.24 105.382 599.24H73.4808C71.5591 599.24 70 597.878 70 596.199V592.286V561.957C70 560.325 71.5168 559 73.3841 559H105.382C107.249 559 108.766 560.325 108.766 561.957V596.283Z",
    fill: "#F1FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3819 581.674C84.1789 581.674 79.9609 585.632 79.9609 590.521V590.569H98.8089V590.521C98.8089 585.638 94.5909 581.674 89.3819 581.674Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1079 578.767C92.5311 578.44 94.2654 576.386 94.2654 574.089V572.79C94.2654 570.494 92.5311 568.439 90.1079 568.113C87.0864 567.708 84.5 569.896 84.5 572.651V574.234C84.5 576.984 87.0924 579.172 90.1079 578.767Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_761_429)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 374,
    width: 397,
    height: 270,
    rx: 8,
    fill: "url(#paint45_linear_761_429)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.5,
    y: 374.5,
    width: 396,
    height: 269,
    rx: 7.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261 372C261 367.582 264.582 364 269 364H650C654.418 364 658 367.582 658 372V389H261V372Z",
    fill: "#F1FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.769 372C261.769 368.007 265.007 364.769 269 364.769H650C653.993 364.769 657.231 368.007 657.231 372V388.231H261.769V372Z",
    stroke: "url(#paint46_linear_761_429)",
    strokeOpacity: 0.31,
    strokeWidth: 1.53846
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.5,
    cy: 376.5,
    r: 4.5,
    fill: "#FF3C53"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 376.5,
    r: 4.5,
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.5,
    cy: 376.5,
    r: 4.5,
    fill: "#00B33D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.727 451L338.727 596.597",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.891 451L367.891 596.597",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 451L490 596.597",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 451L604 596.597",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.648 451L373.648 596.597",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.758 451L495.758 596.597",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.758 451L609.758 596.597",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.336 451L409.336 596.597",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.031 451L440.031 596.597",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.422 451L402.422 596.597",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 474.05L317.235 474.05",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.031 509.008L317.237 509.008",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.031 503.246L317.237 503.246",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.648 451L317.003 573.782",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.031 492.873L359.443 573.551",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.648 527.832L393.792 573.74",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.031 563.559L429.992 573.609",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.242 573.932L620.007 573.932",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.031 544.735L317.237 544.735",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.031 537.82L317.237 537.82",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.38416,
    strokeLinecap: "round",
    strokeDasharray: "1.54 1.54"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_b_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.726 502.862C431.673 502.862 438.116 496.412 438.116 488.456C438.116 480.5 431.673 474.05 423.726 474.05C415.779 474.05 409.336 480.5 409.336 488.456C409.336 496.412 415.779 502.862 423.726 502.862Z",
    fill: "url(#paint47_radial_761_429)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.732 488.456C437.732 496.2 431.461 502.477 423.726 502.477C415.991 502.477 409.72 496.2 409.72 488.456C409.72 480.711 415.991 474.434 423.726 474.434C431.461 474.434 437.732 480.711 437.732 488.456Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.768765,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_b_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.726 537.436C431.673 537.436 438.116 530.986 438.116 523.03C438.116 515.074 431.673 508.624 423.726 508.624C415.779 508.624 409.336 515.074 409.336 523.03C409.336 530.986 415.779 537.436 423.726 537.436Z",
    fill: "url(#paint48_radial_761_429)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.732 523.03C437.732 530.774 431.461 537.052 423.726 537.052C415.991 537.052 409.72 530.774 409.72 523.03C409.72 515.286 415.991 509.008 423.726 509.008C431.461 509.008 437.732 515.286 437.732 523.03Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.768765,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_b_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.726 573.547C431.673 573.547 438.116 567.098 438.116 559.141C438.116 551.185 431.673 544.735 423.726 544.735C415.779 544.735 409.336 551.185 409.336 559.141C409.336 567.098 415.779 573.547 423.726 573.547Z",
    fill: "url(#paint49_radial_761_429)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.732 559.141C437.732 566.886 431.461 573.163 423.726 573.163C415.991 573.163 409.72 566.886 409.72 559.141C409.72 551.397 415.991 545.12 423.726 545.12C431.461 545.12 437.732 551.397 437.732 559.141Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.768765,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_b_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.656 537.436C395.603 537.436 402.046 530.986 402.046 523.03C402.046 515.074 395.603 508.624 387.656 508.624C379.708 508.624 373.266 515.074 373.266 523.03C373.266 530.986 379.708 537.436 387.656 537.436Z",
    fill: "url(#paint50_radial_761_429)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.661 523.03C401.661 530.774 395.39 537.052 387.656 537.052C379.921 537.052 373.65 530.774 373.65 523.03C373.65 515.286 379.921 509.008 387.656 509.008C395.39 509.008 401.661 515.286 401.661 523.03Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.768765,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_b_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.656 573.547C395.603 573.547 402.046 567.098 402.046 559.141C402.046 551.185 395.603 544.735 387.656 544.735C379.708 544.735 373.266 551.185 373.266 559.141C373.266 567.098 379.708 573.547 387.656 573.547Z",
    fill: "url(#paint51_radial_761_429)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.661 559.141C401.661 566.886 395.39 573.163 387.656 573.163C379.921 573.163 373.65 566.886 373.65 559.141C373.65 551.397 379.921 545.12 387.656 545.12C395.39 545.12 401.661 551.397 401.661 559.141Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.768765,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_b_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.117 573.547C361.064 573.547 367.507 567.098 367.507 559.141C367.507 551.185 361.064 544.735 353.117 544.735C345.169 544.735 338.727 551.185 338.727 559.141C338.727 567.098 345.169 573.547 353.117 573.547Z",
    fill: "url(#paint52_radial_761_429)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.122 559.141C367.122 566.886 360.851 573.163 353.117 573.163C345.382 573.163 339.111 566.886 339.111 559.141C339.111 551.397 345.382 545.12 353.117 545.12C360.851 545.12 367.122 551.397 367.122 559.141Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.768765,
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 304.5,
    y: 437.5,
    width: 153,
    height: 161,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.5,
    y: 589.5,
    width: 16,
    height: 16,
    fill: "#5AC1FF",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 589.5,
    width: 16,
    height: 16,
    fill: "#5AC1FF",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.5,
    y: 428.5,
    width: 16,
    height: 16,
    fill: "#5AC1FF",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 428.5,
    width: 16,
    height: 16,
    fill: "#5AC1FF",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.143 599C457.407 599 456 600.407 456 602.143V655.571C456 657.307 457.407 658.714 459.143 658.714C460.128 658.712 461.055 658.249 461.647 657.462L471.463 646.517L482.346 671.654C483.349 673.973 486.067 675.021 488.368 673.974C490.637 672.943 491.642 670.274 490.614 668.002L479.381 643.123L496.857 643C498.593 643 500 641.593 500 639.857C500 638.908 499.571 638.011 498.834 637.414L461.604 600.191C461.009 599.439 460.102 599.001 459.143 599Z",
    fill: "#FFEDE7"
  })), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 500,
    y: 551,
    width: 50,
    height: 10,
    rx: 5,
    fill: "url(#paint53_linear_761_429)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 500,
    y: 536,
    width: 100,
    height: 10,
    rx: 5,
    fill: "url(#paint54_linear_761_429)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 500,
    y: 521,
    width: 100,
    height: 10,
    rx: 5,
    fill: "url(#paint55_linear_761_429)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 500,
    y: 505,
    width: 100,
    height: 10,
    rx: 5,
    fill: "url(#paint56_linear_761_429)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 500,
    y: 488,
    width: 100,
    height: 10,
    rx: 5,
    fill: "url(#paint57_linear_761_429)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.501 729.236H85.0961C79.5201 729.236 75 724.716 75 719.14V694.096C75 688.52 79.5201 684 85.0961 684H111.501C117.077 684 121.597 688.52 121.597 694.096V719.14C121.597 724.716 117.077 729.236 111.501 729.236Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.501 729.236H85.0961C79.5201 729.236 75 724.716 75 719.14V694.096C75 688.52 79.5201 684 85.0961 684H111.501C117.077 684 121.597 688.52 121.597 694.096V719.14C121.597 724.716 117.077 729.236 111.501 729.236Z",
    fill: "#F7FBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.501 729.236H85.0961C79.5201 729.236 75 724.716 75 719.14V694.096C75 688.52 79.5201 684 85.0961 684H111.501C117.077 684 121.597 688.52 121.597 694.096V719.14C121.597 724.716 117.077 729.236 111.501 729.236Z",
    stroke: "#F4F4F4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.406 706.788C110.406 713.419 105.037 718.788 98.4063 718.788C91.7754 718.788 86.4062 713.419 86.4062 706.788C86.4062 700.157 91.7754 694.788 98.4063 694.788C105.023 694.774 110.406 700.157 110.406 706.788Z",
    fill: "url(#paint58_linear_761_429)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3906 701.788V711.559",
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.294 706.682H93.5234",
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.095 729.236H140.69C135.114 729.236 130.594 724.716 130.594 719.14V694.096C130.594 688.52 135.114 684 140.69 684H167.095C172.671 684 177.191 688.52 177.191 694.096V719.14C177.191 724.716 172.671 729.236 167.095 729.236Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.095 729.236H140.69C135.114 729.236 130.594 724.716 130.594 719.14V694.096C130.594 688.52 135.114 684 140.69 684H167.095C172.671 684 177.191 688.52 177.191 694.096V719.14C177.191 724.716 172.671 729.236 167.095 729.236Z",
    fill: "#F7FBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.095 729.236H140.69C135.114 729.236 130.594 724.716 130.594 719.14V694.096C130.594 688.52 135.114 684 140.69 684H167.095C172.671 684 177.191 688.52 177.191 694.096V719.14C177.191 724.716 172.671 729.236 167.095 729.236Z",
    stroke: "#F4F4F4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.086 706.788C166.086 713.419 160.717 718.788 154.086 718.788C147.455 718.788 142.086 713.419 142.086 706.788C142.086 700.157 147.455 694.788 154.086 694.788C160.717 694.774 166.086 700.157 166.086 706.788Z",
    fill: "url(#paint59_linear_761_429)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.75 707.212L152.333 709.788L158.75 702.788",
    fill: "url(#paint60_linear_761_429)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.75 707.212L152.333 709.788L158.75 702.788",
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.901 521.236H171.696C164.684 521.236 159 515.552 159 508.54V477.047C159 470.035 164.684 464.351 171.696 464.351H204.901C211.913 464.351 217.597 470.035 217.597 477.047V508.54C217.597 515.552 211.913 521.236 204.901 521.236Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.901 521.236H171.696C164.684 521.236 159 515.552 159 508.54V477.047C159 470.035 164.684 464.351 171.696 464.351H204.901C211.913 464.351 217.597 470.035 217.597 477.047V508.54C217.597 515.552 211.913 521.236 204.901 521.236Z",
    fill: "#F7FBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.901 521.236H171.696C164.684 521.236 159 515.552 159 508.54V477.047C159 470.035 164.684 464.351 171.696 464.351H204.901C211.913 464.351 217.597 470.035 217.597 477.047V508.54C217.597 515.552 211.913 521.236 204.901 521.236Z",
    stroke: "#F4F4F4",
    strokeWidth: 0.628762,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.833 486.056V496.593C174.833 497.647 175.092 498.458 175.61 499.027C176.129 499.595 176.89 499.88 177.893 499.88C178.897 499.88 179.666 499.595 180.201 499.027C180.737 498.458 181.004 497.647 181.004 496.593V486.056H185.294V496.568C185.294 498.14 184.96 499.47 184.291 500.557C183.622 501.644 182.719 502.464 181.581 503.016C180.461 503.568 179.206 503.844 177.818 503.844C176.43 503.844 175.184 503.576 174.08 503.041C172.993 502.489 172.132 501.669 171.496 500.582C170.86 499.478 170.543 498.14 170.543 496.568V486.056H174.833ZM199.094 503.668L195.507 498.274L192.346 503.668H187.479L193.123 494.712L187.353 486.056H192.346L195.883 491.375L198.994 486.056H203.861L198.266 494.937L204.087 503.668H199.094Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.833 486.056H175.042V485.847H174.833V486.056ZM175.61 499.027L175.455 499.168L175.61 499.027ZM180.201 499.027L180.354 499.17L180.201 499.027ZM181.004 486.056V485.847H180.795V486.056H181.004ZM185.294 486.056H185.504V485.847H185.294V486.056ZM184.291 500.557L184.469 500.667H184.469L184.291 500.557ZM181.581 503.016L181.49 502.827L181.489 502.828L181.581 503.016ZM174.08 503.041L173.985 503.228L173.989 503.229L174.08 503.041ZM171.496 500.582L171.314 500.687L171.315 500.688L171.496 500.582ZM170.543 486.056V485.847H170.333V486.056H170.543ZM174.623 486.056V496.593H175.042V486.056H174.623ZM174.623 496.593C174.623 497.68 174.891 498.548 175.455 499.168L175.765 498.886C175.293 498.368 175.042 497.614 175.042 496.593H174.623ZM175.455 499.168C176.025 499.792 176.85 500.089 177.893 500.089V499.67C176.93 499.67 176.233 499.398 175.765 498.886L175.455 499.168ZM177.893 500.089C178.937 500.089 179.769 499.792 180.354 499.17L180.049 498.883C179.564 499.398 178.856 499.67 177.893 499.67V500.089ZM180.354 499.17C180.937 498.551 181.214 497.681 181.214 496.593H180.795C180.795 497.613 180.536 498.365 180.049 498.883L180.354 499.17ZM181.214 496.593V486.056H180.795V496.593H181.214ZM181.004 486.266H185.294V485.847H181.004V486.266ZM185.085 486.056V496.568H185.504V486.056H185.085ZM185.085 496.568C185.085 498.111 184.757 499.4 184.112 500.447L184.469 500.667C185.163 499.54 185.504 498.17 185.504 496.568H185.085ZM184.112 500.447C183.464 501.501 182.591 502.293 181.49 502.827L181.673 503.204C182.846 502.635 183.779 501.788 184.469 500.667L184.112 500.447ZM181.489 502.828C180.4 503.364 179.178 503.634 177.818 503.634V504.053C179.235 504.053 180.521 503.771 181.674 503.204L181.489 502.828ZM177.818 503.634C176.457 503.634 175.243 503.372 174.171 502.852L173.989 503.229C175.124 503.78 176.402 504.053 177.818 504.053V503.634ZM174.175 502.854C173.125 502.321 172.293 501.53 171.677 500.476L171.315 500.688C171.97 501.809 172.861 502.657 173.985 503.228L174.175 502.854ZM171.678 500.478C171.064 499.412 170.752 498.112 170.752 496.568H170.333C170.333 498.169 170.657 499.544 171.314 500.687L171.678 500.478ZM170.752 496.568V486.056H170.333V496.568H170.752ZM170.543 486.266H174.833V485.847H170.543V486.266ZM199.094 503.668L198.92 503.784L198.982 503.878H199.094V503.668ZM195.507 498.274L195.681 498.158L195.496 497.879L195.326 498.168L195.507 498.274ZM192.346 503.668V503.878H192.466L192.527 503.774L192.346 503.668ZM187.479 503.668L187.301 503.556L187.099 503.878H187.479V503.668ZM193.123 494.712L193.301 494.823L193.373 494.708L193.298 494.595L193.123 494.712ZM187.353 486.056V485.847H186.962L187.179 486.173L187.353 486.056ZM192.346 486.056L192.52 485.94L192.458 485.847H192.346V486.056ZM195.883 491.375L195.709 491.491L195.895 491.771L196.064 491.481L195.883 491.375ZM198.994 486.056V485.847H198.874L198.813 485.951L198.994 486.056ZM203.861 486.056L204.038 486.168L204.241 485.847H203.861V486.056ZM198.266 494.937L198.089 494.826L198.017 494.941L198.092 495.054L198.266 494.937ZM204.087 503.668V503.878H204.478L204.261 503.552L204.087 503.668ZM199.269 503.552L195.681 498.158L195.332 498.39L198.92 503.784L199.269 503.552ZM195.326 498.168L192.165 503.562L192.527 503.774L195.688 498.38L195.326 498.168ZM192.346 503.458H187.479V503.878H192.346V503.458ZM187.656 503.78L193.301 494.823L192.946 494.6L187.301 503.556L187.656 503.78ZM193.298 494.595L187.528 485.94L187.179 486.173L192.949 494.828L193.298 494.595ZM187.353 486.266H192.346V485.847H187.353V486.266ZM192.171 486.173L195.709 491.491L196.058 491.259L192.52 485.94L192.171 486.173ZM196.064 491.481L199.175 486.162L198.813 485.951L195.702 491.269L196.064 491.481ZM198.994 486.266H203.861V485.847H198.994V486.266ZM203.684 485.945L198.089 494.826L198.444 495.049L204.038 486.168L203.684 485.945ZM198.092 495.054L203.912 503.784L204.261 503.552L198.441 494.821L198.092 495.054ZM204.087 503.458H199.094V503.878H204.087V503.458Z",
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.65 676.335H555.35C548.529 676.335 543 670.806 543 663.985V633.35C543 626.529 548.529 621 555.35 621H587.65C594.471 621 600 626.529 600 633.35V663.985C600 670.806 594.471 676.335 587.65 676.335Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.65 676.335H555.35C548.529 676.335 543 670.806 543 663.985V633.35C543 626.529 548.529 621 555.35 621H587.65C594.471 621 600 626.529 600 633.35V663.985C600 670.806 594.471 676.335 587.65 676.335Z",
    fill: "#F7FBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.65 676.335H555.35C548.529 676.335 543 670.806 543 663.985V633.35C543 626.529 548.529 621 555.35 621H587.65C594.471 621 600 626.529 600 633.35V663.985C600 670.806 594.471 676.335 587.65 676.335Z",
    stroke: "#F4F4F4",
    strokeWidth: 0.611621,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.511 640.655V650.904C564.511 651.929 564.763 652.718 565.268 653.271C565.772 653.825 566.512 654.101 567.489 654.101C568.465 654.101 569.213 653.825 569.734 653.271C570.254 652.718 570.515 651.929 570.515 650.904V640.655H574.688V650.88C574.688 652.409 574.362 653.703 573.711 654.76C573.061 655.818 572.182 656.615 571.076 657.152C569.986 657.689 568.766 657.957 567.415 657.957C566.065 657.957 564.853 657.697 563.779 657.176C562.722 656.639 561.884 655.842 561.266 654.784C560.647 653.711 560.338 652.409 560.338 650.88V640.655H564.511ZM581.791 640.655V657.786H577.618V640.655H581.791Z",
    fill: "#3399FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.511 640.655H564.715V640.451H564.511V640.655ZM565.268 653.271L565.117 653.409H565.117L565.268 653.271ZM569.734 653.271L569.882 653.411L569.734 653.271ZM570.515 640.655V640.451H570.311V640.655H570.515ZM574.688 640.655H574.892V640.451H574.688V640.655ZM573.711 654.76L573.885 654.867L573.711 654.76ZM571.076 657.152L570.987 656.968L570.986 656.969L571.076 657.152ZM563.779 657.176L563.687 657.358L563.69 657.359L563.779 657.176ZM561.266 654.784L561.089 654.886L561.09 654.887L561.266 654.784ZM560.338 640.655V640.451H560.134V640.655H560.338ZM564.307 640.655V650.904H564.715V640.655H564.307ZM564.307 650.904C564.307 651.961 564.568 652.806 565.117 653.409L565.418 653.134C564.959 652.63 564.715 651.897 564.715 650.904H564.307ZM565.117 653.409C565.671 654.016 566.473 654.305 567.489 654.305V653.897C566.551 653.897 565.873 653.633 565.418 653.134L565.117 653.409ZM567.489 654.305C568.504 654.305 569.313 654.016 569.882 653.411L569.585 653.132C569.113 653.633 568.425 653.897 567.489 653.897V654.305ZM569.882 653.411C570.449 652.809 570.718 651.963 570.718 650.904H570.311C570.311 651.896 570.059 652.628 569.585 653.132L569.882 653.411ZM570.718 650.904V640.655H570.311V650.904H570.718ZM570.515 640.859H574.688V640.451H570.515V640.859ZM574.484 640.655V650.88H574.892V640.655H574.484ZM574.484 650.88C574.484 652.38 574.165 653.635 573.538 654.653L573.885 654.867C574.56 653.771 574.892 652.438 574.892 650.88H574.484ZM573.538 654.653C572.907 655.678 572.058 656.448 570.987 656.968L571.165 657.335C572.306 656.781 573.214 655.957 573.885 654.867L573.538 654.653ZM570.986 656.969C569.927 657.49 568.738 657.753 567.415 657.753V658.161C568.793 658.161 570.045 657.887 571.166 657.335L570.986 656.969ZM567.415 657.753C566.092 657.753 564.911 657.498 563.868 656.993L563.69 657.359C564.795 657.895 566.038 658.161 567.415 658.161V657.753ZM563.871 656.994C562.85 656.476 562.041 655.706 561.442 654.682L561.09 654.887C561.727 655.977 562.593 656.803 563.687 657.358L563.871 656.994ZM561.442 654.683C560.846 653.646 560.542 652.382 560.542 650.88H560.134C560.134 652.437 560.449 653.775 561.089 654.886L561.442 654.683ZM560.542 650.88V640.655H560.134V650.88H560.542ZM560.338 640.859H564.511V640.451H560.338V640.859ZM581.791 640.655H581.995V640.451H581.791V640.655ZM581.791 657.786V657.99H581.995V657.786H581.791ZM577.618 657.786H577.414V657.99H577.618V657.786ZM577.618 640.655V640.451H577.414V640.655H577.618ZM581.587 640.655V657.786H581.995V640.655H581.587ZM581.791 657.582H577.618V657.99H581.791V657.582ZM577.822 657.786V640.655H577.414V657.786H577.822ZM577.618 640.859H581.791V640.451H577.618V640.859Z",
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.689 729.236H196.284C190.708 729.236 186.188 724.716 186.188 719.14V694.096C186.188 688.52 190.708 684 196.284 684H222.689C228.265 684 232.785 688.52 232.785 694.096V719.14C232.776 724.716 228.256 729.236 222.689 729.236Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.689 729.236H196.284C190.708 729.236 186.188 724.716 186.188 719.14V694.096C186.188 688.52 190.708 684 196.284 684H222.689C228.265 684 232.785 688.52 232.785 694.096V719.14C232.776 724.716 228.256 729.236 222.689 729.236Z",
    fill: "#F7FBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.689 729.236H196.284C190.708 729.236 186.188 724.716 186.188 719.14V694.096C186.188 688.52 190.708 684 196.284 684H222.689C228.265 684 232.785 688.52 232.785 694.096V719.14C232.776 724.716 228.256 729.236 222.689 729.236Z",
    stroke: "#F4F4F4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.789 706.788C221.789 713.419 216.42 718.788 209.789 718.788C203.158 718.788 197.789 713.419 197.789 706.788C197.789 700.157 203.158 694.788 209.789 694.788C216.42 694.774 221.789 700.157 221.789 706.788Z",
    fill: "url(#paint61_linear_761_429)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.241 703.788L206.344 710.699",
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.241 710.699L206.344 703.788",
    stroke: "#F4F4F4",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_bd_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.574 258.434H374.436C371.429 258.434 369 256.005 369 252.998V231.8V55.4364C369 52.4293 371.429 50 374.436 50H403.574C406.581 50 409.01 52.4293 409.01 55.4364V252.998C408.995 255.99 406.566 258.434 403.574 258.434Z",
    fill: "url(#paint62_linear_761_429)",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.574 257.934H374.436C371.705 257.934 369.5 255.729 369.5 252.998V231.8V55.4364C369.5 52.7055 371.705 50.5 374.436 50.5H403.574C406.304 50.5 408.51 52.7055 408.51 55.4364V252.997C408.496 255.716 406.287 257.934 403.574 257.934Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389 64.1914V242.244",
    stroke: "#3399FF",
    strokeWidth: 2.96261,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.262 129.723H388.744C384.048 129.723 380.227 125.917 380.227 121.206C380.227 116.51 384.034 112.688 388.744 112.688H389.262C393.958 112.688 397.78 116.495 397.78 121.206C397.78 125.902 393.973 129.723 389.262 129.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.262 129.723H388.744C384.048 129.723 380.227 125.917 380.227 121.206C380.227 116.51 384.034 112.688 388.744 112.688H389.262C393.958 112.688 397.78 116.495 397.78 121.206C397.78 125.902 393.973 129.723 389.262 129.723Z",
    stroke: "#F4F4F4",
    strokeWidth: 0.740652,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M566.263 50H443.737C441.673 50 440 51.5212 440 53.3977V114.602C440 116.479 441.673 118 443.737 118H566.263C568.327 118 570 116.479 570 114.602V53.3977C570 51.5212 568.327 50 566.263 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.906 67.75H517.526",
    stroke: "#D4E3F8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.906 82.25H555.656",
    stroke: "#D4E3F8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.906 90.8799H555.656",
    stroke: "#D4E3F8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.906 99.5195H519.956",
    stroke: "#D4E3F8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.149 71.4697H454.609V86.0097H469.149V71.4697Z",
    fill: "#3499FF",
    stroke: "#F4F4F4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.556 76.3397H457.336V69.5397C457.336 66.9897 459.396 64.9297 461.946 64.9297C464.496 64.9297 466.556 66.9897 466.556 69.5397V76.3397Z",
    stroke: "#3499FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.149 71.54H454.609V86.08H469.149V71.54Z",
    fill: "#3499FF",
    stroke: "#F4F4F4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.556 76.41H457.336V69.61C457.336 67.06 459.396 65 461.946 65C464.496 65 466.556 67.06 466.556 69.61V76.41Z",
    stroke: "#3499FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.263 138H443.737C441.673 138 440 139.476 440 141.298V200.702C440 202.523 441.673 204 443.737 204H566.263C568.327 204 570 202.523 570 200.702V141.298C570 139.476 568.327 138 566.263 138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.906 155.65H518.526",
    stroke: "#D4E3F8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.906 170.15H556.656",
    stroke: "#D4E3F8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.906 178.79H556.656",
    stroke: "#D4E3F8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.906 187.42H520.956",
    stroke: "#D4E3F8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.049 169.34V161.24C470.049 157.69 467.429 154.75 464.019 154.23V153.59C464.019 153 463.539 152.52 462.949 152.52C462.359 152.52 461.879 153 461.879 153.59V154.23C458.469 154.75 455.849 157.68 455.849 161.24V169.34C454.879 169.82 454.219 170.82 454.219 171.98H455.849H470.049H471.679C471.679 170.82 471.009 169.82 470.049 169.34Z",
    fill: "#3499FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.948 176.43C464.848 176.43 466.378 174.89 466.378 173H459.508C459.508 174.89 461.048 176.43 462.948 176.43Z",
    fill: "#3499FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.639 258.22H454.814C446.667 258.22 440 250.52 440 241.11C440 231.66 446.632 224 454.814 224H499.639C507.821 224 514.453 231.66 514.453 241.11C514.453 250.55 507.821 258.22 499.639 258.22Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.639 258.22H454.814C446.667 258.22 440 250.52 440 241.11C440 231.66 446.632 224 454.814 224H499.639C507.821 224 514.453 231.66 514.453 241.11C514.453 250.55 507.821 258.22 499.639 258.22Z",
    fill: "#F7FBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.639 258.22H454.814C446.667 258.22 440 250.52 440 241.11C440 231.66 446.632 224 454.814 224H499.639C507.821 224 514.453 231.66 514.453 241.11C514.453 250.55 507.821 258.22 499.639 258.22Z",
    stroke: "#F4F4F4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_761_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.602 253.47H458.862C452.032 253.47 446.492 247.93 446.492 241.1C446.492 234.27 452.032 228.73 458.862 228.73H459.602C466.432 228.73 471.972 234.27 471.972 241.1C471.972 247.93 466.432 253.47 459.602 253.47Z",
    fill: "url(#paint63_linear_761_429)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_761_429",
    x: -539.787,
    y: -466.787,
    width: 1112.57,
    height: 1168.54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 167.893,
    result: "effect1_foregroundBlur_761_429"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_761_429",
    x: 113.213,
    y: -110.787,
    width: 1112.57,
    height: 1168.54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 167.893,
    result: "effect1_foregroundBlur_761_429"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_761_429",
    x: -46.3259,
    y: 138.586,
    width: 240.22,
    height: 365.558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.80251
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_429"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -16.247,
    dy: 37.1361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40.6176
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.290196 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_761_429",
    result: "effect2_dropShadow_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bd_761_429",
    x: 70.7678,
    y: 5.90092,
    width: 240.22,
    height: 365.558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.80251
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_429"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -16.247,
    dy: 37.1361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40.6176
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.290196 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_761_429",
    result: "effect2_dropShadow_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bd_761_429",
    x: -47.4744,
    y: 5.90092,
    width: 241.384,
    height: 239.063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.80251
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_429"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -16.247,
    dy: 37.1361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40.6176
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.290196 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_761_429",
    result: "effect2_dropShadow_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_761_429",
    x: -34,
    y: 326,
    width: 748,
    height: 479,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -14,
    dy: 32
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.28839 0 0 0 0 0.458333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_761_429",
    x: 0,
    y: 489,
    width: 361,
    height: 264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_761_429",
    x: 211,
    y: 324,
    width: 497,
    height: 370,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_761_429",
    x: 312.812,
    y: 446.808,
    width: 311.383,
    height: 153.981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_b_761_429",
    x: 399.336,
    y: 464.05,
    width: 48.7812,
    height: 48.8115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_b_761_429",
    x: 399.336,
    y: 498.624,
    width: 48.7812,
    height: 48.8115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_b_761_429",
    x: 399.336,
    y: 534.735,
    width: 48.7812,
    height: 48.8115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_b_761_429",
    x: 363.266,
    y: 498.624,
    width: 48.7812,
    height: 48.8115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_b_761_429",
    x: 363.266,
    y: 534.735,
    width: 48.7812,
    height: 48.8115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_b_761_429",
    x: 328.727,
    y: 534.735,
    width: 48.7812,
    height: 48.8115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_761_429",
    x: 416,
    y: 563,
    width: 124,
    height: 155.381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_761_429",
    x: -14.8813,
    y: 643.203,
    width: 196.479,
    height: 195.122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -14.9385,
    dy: 34.1453
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.3464
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.290196 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_761_429",
    x: 40.7125,
    y: 643.203,
    width: 196.479,
    height: 195.122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -14.9385,
    dy: 34.1453
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.3464
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.290196 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_761_429",
    x: 45.9739,
    y: 413.047,
    width: 247.083,
    height: 245.371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -18.7856,
    dy: 42.9385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 46.964
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.290196 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_761_429",
    x: 433.054,
    y: 571.095,
    width: 240.344,
    height: 238.681,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -18.2735,
    dy: 41.7679
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.6837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.290196 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_761_429",
    x: 96.3062,
    y: 643.203,
    width: 196.479,
    height: 195.122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -14.9385,
    dy: 34.1453
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.3464
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.290196 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_bd_761_429",
    x: 236.229,
    y: -10.0631,
    width: 261.293,
    height: 429.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.90304
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_429"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -22.1285,
    dy: 50.5795
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 55.3213
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.290196 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_761_429",
    result: "effect2_dropShadow_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_761_429",
    x: 356.159,
    y: 94.5427,
    width: 77.5412,
    height: 77.0275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.92521,
    dy: 11.8504
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.813
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.055625 0 0 0 0 0.264013 0 0 0 0 0.370833 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_761_429",
    x: 430.492,
    y: 212.73,
    width: 65.4766,
    height: 64.7402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.6 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_761_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_761_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_761_429",
    x1: 312,
    y1: 770,
    x2: -372,
    y2: 770,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_761_429",
    x1: 312,
    y1: 750,
    x2: -372,
    y2: 750,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_761_429",
    x1: 312,
    y1: 730,
    x2: -372,
    y2: 730,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_761_429",
    x1: 312,
    y1: 710,
    x2: -372,
    y2: 710,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_761_429",
    x1: 312,
    y1: 690,
    x2: -372,
    y2: 690,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_761_429",
    x1: 312,
    y1: 670,
    x2: -372,
    y2: 670,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_761_429",
    x1: 312,
    y1: 650,
    x2: -372,
    y2: 650,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_761_429",
    x1: 312,
    y1: 629.999,
    x2: -372,
    y2: 629.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_761_429",
    x1: 312,
    y1: 609.999,
    x2: -372,
    y2: 609.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_761_429",
    x1: 312,
    y1: 589.999,
    x2: -372,
    y2: 589.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_761_429",
    x1: 312,
    y1: 569.999,
    x2: -372,
    y2: 569.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_761_429",
    x1: 312,
    y1: 549.999,
    x2: -372,
    y2: 549.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_761_429",
    x1: 312,
    y1: 529.999,
    x2: -372,
    y2: 529.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_761_429",
    x1: 312,
    y1: 509.999,
    x2: -372,
    y2: 509.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_761_429",
    x1: 312,
    y1: 489.999,
    x2: -372,
    y2: 489.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_761_429",
    x1: 312,
    y1: 469.999,
    x2: -372,
    y2: 469.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_761_429",
    x1: 312,
    y1: 449.999,
    x2: -372,
    y2: 449.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_761_429",
    x1: 17,
    y1: 18,
    x2: 701,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_761_429",
    x1: 17,
    y1: 38,
    x2: 701,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_761_429",
    x1: 17,
    y1: 58,
    x2: 701,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_761_429",
    x1: 17,
    y1: 78,
    x2: 701,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_761_429",
    x1: 17,
    y1: 98,
    x2: 701,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_761_429",
    x1: 17,
    y1: 118,
    x2: 701,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_761_429",
    x1: 17,
    y1: 138,
    x2: 701,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_761_429",
    x1: 17,
    y1: 158,
    x2: 701,
    y2: 158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_761_429",
    x1: 17,
    y1: 178.001,
    x2: 701,
    y2: 178.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_761_429",
    x1: 17,
    y1: 198.001,
    x2: 701,
    y2: 198.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_761_429",
    x1: 17,
    y1: 218.001,
    x2: 701,
    y2: 218.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_761_429",
    x1: 17,
    y1: 238.001,
    x2: 701,
    y2: 238.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_761_429",
    x1: 17,
    y1: 258.001,
    x2: 701,
    y2: 258.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_761_429",
    x1: 17,
    y1: 278.001,
    x2: 701,
    y2: 278.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_761_429",
    x1: 17,
    y1: 298.001,
    x2: 701,
    y2: 298.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_761_429",
    x1: 17,
    y1: 318.001,
    x2: 701,
    y2: 318.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_761_429",
    x1: 17,
    y1: 338.001,
    x2: 701,
    y2: 338.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_761_429",
    x1: 17,
    y1: 358.001,
    x2: 701,
    y2: 358.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00146199,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_761_429",
    x1: 166.907,
    y1: 182.686,
    x2: 267.111,
    y2: 262.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_761_429",
    x1: 284.001,
    y1: 50,
    x2: 384.205,
    y2: 130.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_761_429",
    x1: 143.254,
    y1: 50,
    x2: 200.218,
    y2: 66.9431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_761_429",
    x1: 298.838,
    y1: 695.787,
    x2: 59.0145,
    y2: 586.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.23
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_761_429",
    x1: 150.375,
    y1: 575.11,
    x2: 150.375,
    y2: 576.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_761_429",
    x1: 158.915,
    y1: 586.69,
    x2: 158.915,
    y2: 587.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_761_429",
    x1: 177.545,
    y1: 607.92,
    x2: 177.545,
    y2: 608.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_761_429",
    x1: 177.545,
    y1: 617.97,
    x2: 177.545,
    y2: 618.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_761_429",
    x1: 152.11,
    y1: 628.02,
    x2: 152.11,
    y2: 629.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_761_429",
    x1: 137.285,
    y1: 563,
    x2: 137.285,
    y2: 564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_761_429",
    x1: 639.5,
    y1: 632.125,
    x2: 265.298,
    y2: 474.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.23
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_761_429",
    x1: 459.5,
    y1: 364,
    x2: 459.5,
    y2: 389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_761_429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(423.726 488.456) rotate(90) scale(14.406 14.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_761_429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(423.726 523.03) rotate(90) scale(14.406 14.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_761_429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(423.726 559.141) rotate(90) scale(14.406 14.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_761_429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(387.656 523.03) rotate(90) scale(14.406 14.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_761_429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(387.656 559.141) rotate(90) scale(14.406 14.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_761_429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(353.117 559.141) rotate(90) scale(14.406 14.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_761_429",
    x1: 525,
    y1: 551,
    x2: 525,
    y2: 561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_761_429",
    x1: 550,
    y1: 536,
    x2: 550,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_761_429",
    x1: 550,
    y1: 521,
    x2: 550,
    y2: 531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_761_429",
    x1: 550,
    y1: 505,
    x2: 550,
    y2: 515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_761_429",
    x1: 550,
    y1: 488,
    x2: 550,
    y2: 498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_761_429",
    x1: 86.395,
    y1: 706.782,
    x2: 110.403,
    y2: 706.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4088FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5658,
    stopColor: "#40A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40B2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_761_429",
    x1: 142.083,
    y1: 706.782,
    x2: 166.091,
    y2: 706.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BE620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5658,
    stopColor: "#2FC02C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28CC56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_761_429",
    x1: 149.749,
    y1: 706.286,
    x2: 158.752,
    y2: 706.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BE620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5658,
    stopColor: "#2FC02C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28CC56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_761_429",
    x1: 197.781,
    y1: 706.782,
    x2: 221.788,
    y2: 706.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4088FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5658,
    stopColor: "#40A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40B2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_761_429",
    x1: 343.5,
    y1: 22.5,
    x2: 634,
    y2: 417.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_761_429",
    x1: 446.495,
    y1: 241.103,
    x2: 471.97,
    y2: 241.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4088FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5658,
    stopColor: "#40A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40B2FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_761_429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 780,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1);
export default __webpack_public_path__ + "static/media/service-1.e148fff58261da94332a66f23bf589c0.svg";
export { ForwardRef as ReactComponent };